import React from 'react';
import { BarChart, Bar, Cell, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';

import {colors, formatChartMoney, formatMoney} from '../../common';

const VerticalBarChart = ({data, columns, labelWidth=300}) => {

    const formattedData = data.slice(0, 10);

    return (
      <ResponsiveContainer width="99%" height={400} style={{marginBottom: 20}}>
        <BarChart
          layout="vertical"
          width={500}
          height={450}
          data={formattedData}
          margin={{
            top: 20,
            right: 30,
            left: 20,
            bottom: 5,
          }}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis type="number" tickFormatter={(value) => formatChartMoney(value)} />
          <YAxis type="category" dataKey="name" width={labelWidth} />
          <Tooltip
            formatter={(value, name, props) => [formatMoney(value), name]}
          />
          <Legend />
          {Object.keys(columns).map(column => (
            <Bar
              key={`column-${column}`}
              dataKey={columns[column]}
              stackId="a"
              fill={colors[column]}
            />
          ))}
        </BarChart>
      </ResponsiveContainer>
    );
};

export default VerticalBarChart;
